var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-dm-import"},[_c('d-remote-monitoring-import',{staticClass:"page-dm-import__monitoring",attrs:{"is-gov-user":_vm.isGovUser,"has-doctor-id":_vm.hasDoctorId},on:{"openDoctorAuth":_vm.openDoctorAuth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }